import axios from 'axios'
const play = () => {
  //Search/CoordinatorImage/{id}

  const proxy = ''// 'https://cors-anywhere.herokuapp.com/'

  axios.get(`${proxy}http://api.bat-ami.org.il/Api/Search/CoordinatorImage`, {
    params: {
      id: 284

    }
  })
    .then(res => {
      //console.log('res-img', res.data.toString())
      return
      //globalResults = res
      //appendResults( globalResults )
      //return globalResults
    })
    .catch(err => console.error(err))
}

export default play